// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Sx","question":"e_Tx","button":"e_Ux","buttonNegative":"e_Vx","buttonPositive":"e_Wx","icon":"e_Xx","iconNegative":"e_Yx","iconPositive":"e_Zx"};